export default __webpack_public_path__ + "static/media/SortAsc.811e3578.svg";